<template>
  <div class="wrapper">
    <lastpage></lastpage>
    <ul class="deta_list">
      <li>
        <span>【预约院区】</span>
        <span>{{ hspName }}</span>
      </li>
      <li>
        <span>【预约科室】</span>
        <span>{{ doctorInfo.DeptName }}</span>
      </li>
      <li>
        <span>【预约医生】</span>
        <span>{{ doctorInfo.DoctorName }}</span>
      </li>
      <li>
        <span>【预约费用】</span>
        <span style="color: #CD3333;">￥{{ doctorInfo.Fee }}</span>
      </li>
      <li>
        <span>【预约时间】</span>
        <span>{{ clinicDate }} {{ timeData2.today }} {{ timeData2.wu }}</span>
      </li>
      <li>
        <span>【预约时间段】</span>
        <span>{{ timeData.TimeDesc.split(" ")[1].replace(/-/g, "~") }}</span>
      </li>
      <li>
        <span>【当前支付方式】</span>
        <span style="color: blue">{{
          radio == "0" ? "自费支付" : "医保支付"
        }}</span>
      </li>
      <li class="mode">
        <el-radio v-model="radio" label="0">自费</el-radio>
        <el-radio v-model="radio" label="1">医保</el-radio>
      </li>
    </ul>
    <!-- <div @click="order2" class="yygh"> -->
    <div @click="order" class="yygh">
      <van-button type="info">预约挂号</van-button>
    </div>
  </div>
</template>

<script>
import { LockRegOrder, pay, payRegOrder, CancelLockRegOrder } from "@/request/api.js";
import { throttle, debounce } from "@/tool/shake.js";
import { Dialog } from "vant";
import lastpage from "@/components/lastpage/lastpage.vue";
export default {
  components: {
    lastpage
  },
  data() {
    return {
      clinicDate: "",
      card: {},
      doctorInfo: {},
      timeData: {},
      timeData2: {},
      hspName: sessionStorage.getItem("hspName"),
      radio: "0",
      isLoading: false
    };
  },
  created() {
    this.clinicDate = this.$moment(
      sessionStorage.getItem("clinicDate").replace(/\-/g, "/")
    ).format("YYYY-MM-DD");
    this.card = JSON.parse(sessionStorage.getItem("card"));
    this.doctorInfo = JSON.parse(sessionStorage.getItem("doctorInfo"));
    this.timeData = JSON.parse(sessionStorage.getItem("timeData"));
    this.timeData2 = JSON.parse(sessionStorage.getItem("timeData2"));
    // this.order2 = debounce(this.order, 400);
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == "/countDown") {
        vm.$router.push("/mySubscribe");
      } else if (from.path == "/mySubscribe") {
        vm.$router.go(-1);
      }
    });
  },
  methods: {
    async order() {
      // this.Dialog.confirm({
      //   title: "预约挂号",
      //   message: "请确认预约信息，再次点击确定预约",
      // }).then(async () => {
      try {
        if(this.isLoading) return
        let map = {
          deptname: this.hspName,
          doctor: this.doctorInfo.DoctorName,
          parentdeptname: this.doctorInfo.DeptName,
          patientname: this.card.patientname,
          hspcode: sessionStorage.getItem("hspCode"),
          lockRegOrderPo: {
            clinicDate: this.clinicDate,
            deptID: this.doctorInfo.DeptID,
            doctorId: this.doctorInfo.DoctorId,
            patientID: this.card.patientId,
            regType:
              this.clinicDate == this.$moment().format("YYYY-MM-DD") ? 0 : 1,
            timeId: this.timeData.TimeId,
            cardNo: this.card.cardno,
            idCardNo: this.card.idcardno,
            regTypeId: this.timeData.RegTypeId,
            isYb: this.radio == "0" ? false : true
          },
          openid: this.card.openid,
          visitingtime: this.timeData.TimeDesc,
          regFee: Number(this.doctorInfo.Fee)
        };
        this.isLoading = true
        let res = await LockRegOrder(map);
        this.isLoading = false
        if (res.data.message == "操作成功") {
          if (this.radio == 1 && res.data.obj.fee == res.data.obj.regAmount) {
            Dialog.alert({
              message: "查无医保，请自费支付"
            }).then(async () => {
              // this.pay(res);
              this.cancle(res);
            });
          } else {
            Dialog.alert({
              message: "预约成功"
            }).then(async () => {
              this.pay(res);
            });
          }
        } else {
          this.Toast.fail(`预约失败，${res.data.message}`);
        }
      } catch (error) {
        this.isLoading = false
        this.Toast(JSON.stringify(error));
      }
      // }).catch(() => {});
    },

    async pay(res) {
      if (this.doctorInfo.Fee == 0) {
        let confirmPayMap = {
          bankTranInfo: "",
          clinicDate: this.clinicDate,
          deptID: this.doctorInfo.DeptID,
          doctorId: this.doctorInfo.DoctorId,
          fee: 0,
          lockID: res.data.obj.lockid,
          orderId: res.data.obj.lockid,
          patientID: this.card.patientId,
          payTag: 2,
          policyInfo: "",
          regType:
            this.clinicDate == this.$moment().format("YYYY-MM-DD") ? 0 : 1,
          selfTranNo: "",
          timeId: this.timeData.TimeId
        };
        let cpres = await payRegOrder(confirmPayMap);
        if (cpres.data.message == "操作成功") {
          this.$router.push("/mySubscribe");
        }
      } else {
        sessionStorage.setItem("tradeid", res.data.obj.tradeid);
        sessionStorage.setItem("order", JSON.stringify(res.data.obj));
        // this.Toast.success("预约成功");
        // this.$router.push("/mySubscribe");
        let paymap = {
          flag: 1, // 1=挂号缴费 2=门诊缴费 3=住院充值
          payTypeId: 1,
          orderDate: res.data.obj.regtime.slice(0, 10),
          orderTime: this.$moment().format("HH:mm:ss"),
          orderTimeoutDate: "",
          orderNo: res.data.obj.lockid,
          currencyCode: 156,
          // orderAmount: 0.01,
          // orderAmount: res.data.obj.fee,
          orderAmount:
            this.radio == "0" ? res.data.obj.fee : res.data.obj.regAmount,
          fee:
            this.radio == "0" ? res.data.obj.fee : res.data.obj.regAmount,
          payInDepositOrderPo: {}, // 入住院缴费实体
          payOpChargePo: {}, // 门诊缴费实体
          subsidAmount: "",
          expireDate: "",
          accountNo: "",
          openID: res.data.obj.openid,
          orderDesc: "医院公众号预约挂号",
          receiverAddress: "",
          buyIp: ""
        };
        let rs = await pay(paymap);
        let that = this;
        function onBridgeReady() {
          WeixinJSBridge.invoke(
            "getBrandWCPayRequest",
            {
              appId: rs.data.obj.sub_appId,
              timeStamp: rs.data.obj.timeStamp,
              nonceStr: rs.data.obj.nonceStr,
              signType: rs.data.obj.signType,
              paySign: rs.data.obj.paySign,
              package: rs.data.obj.package
            },
            function(obj) {
              if (obj.err_msg == "get_brand_wcpay_request:ok") {
                if (res.data.message == "操作成功") {
                  that.Toast.success("支付成功,即将返回预约记录页面");
                  setTimeout(() => {
                    // that.$router.go(-1);
                    that.$router.push("/mySubscribe");
                  }, 1500);
                } else if (obj.err_msg == "get_brand_wcpay_request:cancel") {
                  that.$router.push("/mySubscribe");
                } else {
                  that.$router.push("/mySubscribe");
                }
              }
            }
          );
        }
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
          }
        } else {
          onBridgeReady();
        }
      }
    },

    // 取消预约
    async cancle(res){
      let map = {
        lockID: res.data.obj.lockid,
        userId: "7148"
      }
      let res2 = await CancelLockRegOrder(map);
      if(res2.data.message == '操作成功'){
        this.radio = "0";
      }
      // this.Dialog.confirm({
      //   title: '提示',
      //   message: '确定取消预约？',
      //   confirmButtonColor: "#ee0a24"
      // })
      //   .then(async () => {
      //     let map = {
      //       lockID: id,
      //       userId: "7148"
      //     }
      //     let res = await CancelLockRegOrder(map);
      //     if(res.data.message == '操作成功'){
      //       this.Toast.success("取消成功")
      //     }
      //   })
      //   .catch(() => {});
    },
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .deta_list {
    // margin-top: 10px;
    padding: 30px 28px 14px;
    background: #fff;
    font-size: 15px;
    display: flex;
    flex-flow: column nowrap;
    > li {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      margin-bottom: 14px;
      > span:nth-child(1) {
        font-weight: bold;
      }
      > span:nth-child(2) {
        color: #8b8b8b;
      }
    }
    .mode {
      margin-top: 14px;
      font-weight: bold;
      font-size: 16px;
      justify-content: space-around;
      > span:nth-child(1) {
        color: black;
        letter-spacing: 1px;
      }
      > span {
        position: relative;
        input {
          position: relative;
          top: 3px;
          width: 16px;
          height: 16px;
          margin-right: 1px;
          accent-color: rgb(55, 118, 255);
        }
      }
    }
  }
  /deep/ .yygh {
    position: absolute;
    width: 355px;
    bottom: 40px;
    text-align: center;
    margin: 0px 10px;
    background: rgb(83, 192, 255);
    color: rgb(255, 255, 255);
    .van-button {
      background: rgb(83, 192, 255);
      padding: 24px 0px;
      width: 355px;
      letter-spacing: 1px;
      font-size: 20px;
      border-color: rgb(62, 184, 255);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/AppointmentDetails.vue